module.exports = __webpack_public_path__ + "static/media/Tumble_Terms_of_Service.ac1a8f3a.pdf";